"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayTypeList = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var pay_1 = require("../../model/pay");
var service_1 = require("../../../library/base/service");
var PayTypeList = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(PayTypeList, _super);
    function PayTypeList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '获取支付列表接口';
        _this.code = '500001';
        _this.desc = '获取支付列表接口';
        _this.requestParams = new pay_1.OrderPayRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return PayTypeList;
}(service_1.BaseService));
exports.PayTypeList = PayTypeList;
//# sourceMappingURL=payTypeList.js.map